let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e3wLR")).then(() => parcelRequire('86hzk'));